/* eslint-disable */
export default {
  activeCall: '使用中通话',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
